<template>
  <div class="cadre">
    <div class="h3_remove">
      <h3>Client : {{ client.societe }}</h3>
      <a>
        <i class="material-icons" style="font-size:20px;color:black" @click="closeClient">close</i>
      </a>
    </div>

    <div class="client-container">
      <div class="client-col">
        <div>
          <label>Nom : </label> {{ client.nom }}
        </div>
        <div>
          <label>Prenom : </label> {{ client.prenom }}
        </div>
        <div>
          <label>Tva : </label> {{ client.tva }}
        </div>
      </div>

      <div class="client-col">
        <i class="material-icons" style="font-size:20px;color:gray">home</i> :
        {{ client.adresse.rue }} {{ client.adresse.numero }}, {{ client.adresse.codePostal }} {{
          client.adresse.localite }}
      </div>

      <div class="client-col">
        <div v-if="getCoordonnee('GSM')">
          <i class="material-icons" style="font-size:20px;color:gray">smartphone</i> :
          {{ getCoordonnee('GSM') }}
        </div>
        <div v-if="getCoordonnee('FIXE')">
          <i class="material-icons" style="font-size:20px;color:gray">call</i> :
          {{ getCoordonnee('FIXE') }}
        </div>

        <div v-if="getCoordonnee('EMAIL')">
          <i class="material-icons" style="font-size:20px;color:gray">mail</i> :
          {{ getCoordonnee('EMAIL') }}
        </div>
      </div>
    </div>
    <div class="crud_client">
      <a data-bs-toggle="modal" data-bs-target="#modalEditIdentite">
        <i class="material-icons" style="font-size:20px;color:black">edit</i>
      </a>
      <a>
        <i class="material-icons" style="font-size:20px;color:red">delete</i>
      </a>


    </div>
  </div>
  <br />
  <div class="cadre">
    <table>
      <thead>
        <tr>
          <th>Quantité</th>
          <th>Taille</th>
          <th>Prix</th>
          <th>Date Commande</th>
          <th>Date Livraison</th>
          <th>
            <div class="tab_outils">
              <div>
                <a data-bs-toggle="modal" data-bs-target="#modalEditCommande" v-on:click="editCommande(null)">
                  <i class="material-icons"
                    style="font-size:20px;color:#143D60; display: flex;justify-content: flex-end">add_circle</i>
                </a>
              </div>
            </div>
          </th>
        </tr>

      </thead>
      <tbody v-if="client.commande && client.commande.length">
        <tr v-for="(commande, index) in paginatedItems" :key="commande.id">
          <td>{{ commande.quantiteBois }}</td>
          <td>{{ commande.longueurBois }}</td>
          <td> {{
            (
              (commande.quantiteBois * commande.prixUnitaireBois || 0) +
              (commande.quantiteSac * commande.prixUnitaireSac || 0) +
              (parseFloat(commande.fraisLivraison.prix) || 0) -
              (commande.reduction || 0)
            ).toFixed(2)
          }} €</td>
          <td>{{ this.format(commande.dateCreation) }}</td>
          <td>{{ commande.livraison ? this.format(commande.livraison.dateLivraison) : '' }}</td>
          <td>
            <div class="tab_outils">
              <div>
                <a data-bs-toggle="modal" data-bs-target="#modalInfoCommande" v-on:click="viewCommande(commande.id)">
                  <i class="material-icons" style="font-size:20px;color: cornflowerblue">visibility</i>
                </a>
              </div>
              <div>
                <a data-bs-toggle="modal" data-bs-target="#modalEditCommande" v-on:click="editCommande(commande.id)">
                  <i class="material-icons" style="font-size:20px;color:black">edit</i>
                </a>
              </div>
              <div>
                <a v-on:click="deleteCommande(index)">
                  <i class="material-icons" style="font-size:20px;color:red">delete</i>
                </a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot v-else>
        <tr>
          <td colspan="7" class="emptyTableMessage">Aucune commandes trouvé</td>
        </tr>
      </tfoot>
    </table>
    <div class="pagination">

      <a v-on:click="previousPage()" :disabled="currentPage === 1">
        <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_left</i>
      </a>
      <span>Page {{ currentPage }} sur {{ totalPages }}</span>
      <a v-on:click="nextPage()" :disabled="currentPage === totalPages">
        <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_right</i>
      </a>
    </div>
  </div>

  <CommandeEdit :params="{ id: commandeEditId, idIdentite: client.id }" @saved="getClient(client.id)" />
  <CommandeInfo :params="{ id: commandeInfoId }" />
  <ClientEdit :params="{ id: client.id }" @saved="getClient(client.id)" />
</template>

<script>
import Axios from '@/services/axios.service';
import DateFormatService from '@/services/dateFormat.service';
import PaginationService from '@/services/pagination.service';

import CommandeEdit from '../../gestionCommande/commande/CommandeEdit.vue';
import CommandeInfo from '../../gestionCommande/commande/CommandeInfo.vue';
import ClientEdit from './ClientEdit.vue';

export default {
  name: 'ClientInfo',
  mixins: [PaginationService, DateFormatService],
  components: {
    ClientEdit, CommandeEdit, CommandeInfo
  },
  data() {
    return {
      client: {
        adresse: {}
      },
      commandeEditId: null,
      commandeInfoId: null,

    };
  },
  mounted() {
    if (this.id) {
      this.getClient(this.id);
    }
  },
  props: ['id'],
  methods: {
    getClient(id) {
      Axios.get('/identite/' + id)
        .then((res) => {
          this.items = res.data.commande
          this.client = res.data
        }).catch(err => {
          console.error('Erreur lors du chargement des commandes :', err);
        });
    },
    getCoordonnee(type) {
      if (this.client && Array.isArray(this.client.coordonnee)) {
        const coord = this.client.coordonnee.find(c => c.typeCoordonnee === type);
        return coord ? coord.information : null;
      }
      return null;
    },
    editCommande(id) {
      this.commandeEditId = id;
    },
    deleteCommande(index) {
      Axios.delete('/commande/' + this.client.commande[index].id)
        .then(response => {
          if (response.status == 200) {
            this.client.commande.splice(index, 1)
          }
        })
        .catch(err => {
          console.error('Erreur lors de la suppression de la commande :', err);
        });
    },
    viewCommande(id) {
      this.commandeInfoId = id;
    },
    closeClient() {
      this.$router.push({ name: 'clientIndex', params: {} })
    },
  }
}
</script>

<style scoped>
.emptyTableMessage {
  text-align: center;
  color: red
}

.client-container {
  display: flex;
  gap: 20px;
}

.client-col {
  flex: 1;
}

.crud_client {
  text-align: right;
}
</style>